import { EventEmitter } from "@/app/utils/event-emitter.class.ts";
import { useClassFactory } from "@pasta/box-v2";

export class SignEvents extends EventEmitter<{
  createPos: () => void;
  placePending: (id: number) => void;
  delete: (id: string) => void;
  deleteObjects: (type: "signPos" | "pendingSign", pageIndex?: number) => void;
}> {}

export const [SignEventsToken, useSignEvents] = useClassFactory(SignEvents);
